import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { FormatDateType } from '../types/format-date.type';

/**
 * Die Formate tragen das deutsche ` [Uhr]` als Literal. Pro dayjs-Locale (= Oberflächensprache, siehe `LanguageService`)
 * wird es ersetzt: Französisch schreibt „14:30 h", Italienisch und Englisch lassen den Zusatz weg.
 */
const TIME_SUFFIX_BY_DAYJS_LOCALE: Record<string, string> = {
  'fr-ch': ' [h]',
  'it-ch': '',
  'en-gb': '',
};

export const localizeTimeSuffix = function (format: string): string {
  const timeSuffix = TIME_SUFFIX_BY_DAYJS_LOCALE[dayjs.locale()];
  return timeSuffix === undefined ? format : format.replace(' [Uhr]', timeSuffix);
};

export const getFormattedDate = function (date: string | Date | undefined | null, format: FormatDateType): string {
  if (!date) {
    return '-';
  }
  if (format === 'week') {
    return dayjs(date).isoWeek().toString();
  } else {
    return dayjs(date).format(localizeTimeSuffix(format));
  }
};
